var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('img',{attrs:{"src":"https://i.gtimg.cn/club/item/face/img/2/16022_100.gif"}}),_c('div',{staticClass:"t"},[_c('div',{staticClass:"title"},[_vm._v("晚上好")]),_c('div',{staticClass:"stitle"},[_vm._v("重磅更新：主题配置功能背景配置，横向布局重构")])])])
}]

export { render, staticRenderFns }